class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.modalContent = this.querySelector('.modal__content');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    this.modalContent.animate(openingAnimation(this.modalContent), animTiming);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    document.querySelector('.openbtn1').classList.remove('active');
    document.querySelector('body').classList.remove('ygb-menuopen');

    setTimeout(function() {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }.bind(this), 300);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    const closingAnim = this.modalContent.animate(closingAnimation(this.modalContent), animTiming);
    closingAnim.onfinish = () => {
      this.detailsContainer.removeAttribute('open');
    };
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

// Animation time and easing
const animTiming = {
  duration: 300,
  easing: "ease-in-out",
};
// Keyframes on Closing animation
const closingAnimation = (hoge) => [
  { height: "100vh" },
  { height: 0 }
];
// Keyframes on Opening animation
const openingAnimation = (hoge) => [
  { height: 0 },
  { height: "100vh" }
];